module.exports = __webpack_public_path__ + "media/images/people/boy-8-4bca46a22fbd592fa3b6ae811b79925d.webp";